import { Type } from 'class-transformer';
import { CommonModel } from 'common/repositories/common.model';

// Model

export class AirlineContactModel {
  id: string;
  name: string;
  email: string;
  phone: string;
  description?: string | null;
}

export class AirlineLiteModel extends CommonModel {
  code: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  phone_2?: string | null;

  @Type(() => AirlineContactModel)
  contact?: AirlineContactModel | null;
}

export class AirlineModel extends AirlineLiteModel {
  preferences: string[];
}

// Input

export type getAirlinesInput = {
  params: {
    page: number;
    limit?: number;
    filter?: string;
    sort?: string;
    q?: string;
  };
};

export type getAirlineInput = {
  id: string;
};

export type AirlineContactInput = {
  id?: string;
  name: string;
  email: string;
  phone: string;
  description?: string | null;
};

export type AirlineMutationInput = {
  // REQUIRED
  code: string;
  name: string;
  address: string;
  phone: string;
  email: string;
  contact: AirlineContactInput;
  preferences: string[];

  // optional
  phone_2?: string | null;
};

export type AirlineUpdateInput = {
  airlineId: string;
  body: AirlineMutationInput;
};

export type AirlineDeleteInput = {
  airlineId: string;
};
